<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M801 503v-89H414v92h270v2C570 626 493 791 488 956h117c7-167 77-334 196-453zM599 124c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528z" />
  </svg>
</template>
